import React from 'react';
import {Link, useHistory} from "react-router-dom";
import './App.css';
import AuthManager from "./AuthManager";

function Footer() {
    let history = useHistory();

    function logout() {
        let authManager = new AuthManager();
        authManager.logout();

        history.push('/login');
    }

    return (
        <div className="footer">
            &copy; 2025 BDH - Version 1.2.4<br/>
            <Link to="/imprint">Impressum & Datenschutz</Link>
        </div>
    );
}

export default Footer;
